var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.8,7.1c0,0.3-0.2,0.5-0.5,0.5H4l2.5,2.5c0.2,0.2,0.2,0.5,0,0.7C6.4,10.9,6.3,11,6.2,11c-0.1,0-0.3,0-0.4-0.1L2.4,7.4 C2.3,7.3,2.2,7.2,2.2,7.1c0-0.1,0-0.3,0.2-0.4l3.4-3.4c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7L4,6.6h17.3 C21.5,6.6,21.8,6.8,21.8,7.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.8,16.9c0,0.1,0,0.3-0.2,0.4l-3.4,3.4c-0.1,0.1-0.2,0.1-0.4,0.1s-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l2.5-2.5H2.8 c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5H20l-2.5-2.5c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0l3.4,3.4 C21.7,16.7,21.8,16.8,21.8,16.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactions);
export default __webpack_public_path__ + "static/media/icon-transactions.e6b1a1ed705947a005c4fccf30580532.svg";
export { ForwardRef as ReactComponent };